import React from "react";
import { motion } from 'framer-motion';
import OurWorkImage from '../../assets/images/ourwork.svg';
import DonationButton from "./DonateButton";

export default function OurWork({ id }) {
    const titleClass = 'font-bold lg:text-xl text-left text-md py-1'
    return (
        <motion.div
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeInOut" }}
            viewport={{ once: true, amount: 0.3 }}
            id={id} className="bg-white flex flex-col items-center w-full mx-auto px-4 py-10 lg:py-0 scroll-mt-36">
            <div className="text-center lg:text-left mb-10 lg:mb-0">
                <span className="bg-idarkblue text-white text-4xl font-lato font-bold px-2 py-1 lg:text-8xl">Nuestro trabajo es</span>
                <p className="text-2xl font-bold lg:text-[66px] w-full lg:pt-7 lg:pb-4 text-right">posible gracias a donativos</p>
                <p className="text-right text-xl font-bold lg:text-right lg:text-4xl">que se reflejan en:</p>
            </div>

            <div className="flex flex-col lg:flex-row lg:h-dvh space-y-6 lg:space-y-0 lg:space-x-10 items-center lg:p-20 lg:pt-0">
                <div className="font-lato flex flex-col lg:space-y-4 text-center lg:text-left space-y-1 order-1 lg:order-2 lg:pl-7">
                    <p className={titleClass}>• Subsidiar pruebas de detección de ITS y consejerías</p>
                    <p className={titleClass}>• Brindar insumos para el cuidado de la salud sexual como condones, lubricantes, PrEP y PEP</p>
                    <p className={titleClass}>• Realizar actividades y eventos enfocados en mejorar el autocuidado y eliminar el estigma</p>
                    <p className={titleClass}>• Brindar una remuneración justa a nuestra equipa y mantener nuestro Centro de Atención para el Cuidado Placentero</p>
                    <p className={titleClass}>• Desarrollar programas de prevención y atención enfocados en hombres que tienen sexo con hombres, mujeres trans, personas que consumen sustancias, personas que viven con VIH y personas que ejercen el trabajo sexual</p>
                    <div className="flex justify-center">
                        <DonationButton />
                    </div>
                </div>
                <img
                    src={OurWorkImage}
                    alt="Nuestro trabajo"
                    className="w-10/12 lg:w-5/12 mx-auto order-2 lg:order-1"
                />
            </div>
        </motion.div>

    );
}

